
import { Reducer } from 'redux';
import { ACTION, RequestExecuteFavourite, ReceiveExecuteFavourite, FailExecuteFavourite } from './action-types';
import * as actions from './action-types';
import { ChartState, EXECUTE_STATUS } from './types-store';

export const INITIAL_STATE: ChartState = {
  favouriteValid: true,

  layoutTypes: undefined,
  selectionReport: undefined,
  selectionReportLayout: undefined,
  executeStatus: EXECUTE_STATUS.IDLE,
  executeRequestId: 0,
  errorsExecuteFailed: undefined,
  fetchingOptionsDrillDownTo: false,
  optionsDrillDownTo: undefined
};

export const chartReducers: { [indexer: string]: (state: ChartState, action: any) => ChartState } = {
  //#region General
  [ACTION.CLEAR_SELECTION_REPORT_STATE]: (state: ChartState,
    action: actions.ClearSelectionReportState
  ): ChartState => {
    return {
      ...state,
      ...INITIAL_STATE
    };
  },
  [ACTION.REQUEST_LAYOUT_TYPES]: (state: ChartState,
    action: actions.RequestLayoutTypes
  ): ChartState => {
    return {
      ...state
    };
  },
  [ACTION.RESPONSE_LAYOUT_TYPES]: (state: ChartState,
    action: actions.ResponseLayoutTypes
  ): ChartState => {
    return {
      ...state,
      layoutTypes: action.data
    };
  },
  [ACTION.FAVOURITE_NOT_VALID]: (state: ChartState,
    action: actions.FavouriteNotValid
  ): ChartState => {
    return {
      ...state,
      favouriteValid: false,
      executeStatus: EXECUTE_STATUS.IDLE,
      selectionReport: undefined
    };
  },
  /**
   * Run when starting fetching data for a case report favourite.
   */
  [ACTION.REQUEST_EXECUTE_FAVOURITE]: (state: ChartState,
    action: RequestExecuteFavourite): ChartState => {

    return {
      ...state,
      favouriteValid: true,
      executeStatus: EXECUTE_STATUS.PENDING,
      selectionReport: undefined,
      selectionReportLayout: undefined,
      executeRequestId: state.executeRequestId + 1,
      errorsExecuteFailed: undefined
    };
  },

  /**
   * Run when finished fetching data for case report favourite.
   */
  [ACTION.RESPONSE_EXECUTE_FAVOURITE]: (state: ChartState,
    action: ReceiveExecuteFavourite): ChartState => {

    if (action.requestId === state.executeRequestId) {
      return {
        ...state,
        executeStatus: EXECUTE_STATUS.SUCCEEDED,
        selectionReport: action.data,
        selectionReportLayout: action.layout,
        errorsExecuteFailed: undefined
      };
    }
    return state;
  },

  [ACTION.FAIL_EXECUTE_FAVOURITE]: (state: ChartState,
    action: FailExecuteFavourite): ChartState => {

    return {
      ...state,
      executeStatus: EXECUTE_STATUS.FAILED,
      selectionReport: undefined,
      selectionReportLayout: undefined,
      errorsExecuteFailed: action.errorsExecuteFailed
    };
  },

  [ACTION.REQUEST_OPTIONS_DRILL_DOWN_TO]: (state: ChartState,
    action: actions.RequestOptionsDrillDownTo
  ): ChartState => {
    return {
      ...state,
      fetchingOptionsDrillDownTo: true
    };
  },
  
  [ACTION.RESPONSE_OPTIONS_DRILL_DOWN_TO]: (state: ChartState,
    action: actions.ResponseOptionsDrillDownTo
  ): ChartState => {
    return {
      ...state,
      fetchingOptionsDrillDownTo: false,
      optionsDrillDownTo: action.data
    };
  },

  [ACTION.REQUEST_DRILLDOWN_LAYOUT_TYPES]: (state: ChartState,
    action: actions.RequestDrillDownOptionsLayoutTypes
  ): ChartState => {
    return {
      ...state,
      fetchingLayoutTypesDrillDownTo: true
    };
  },

  [ACTION.RESPONSE_DRILLDOWN_LAYOUT_TYPES]: (state: ChartState,
    action: actions.ResponseDrillDownOptionsLayoutTypes
  ): ChartState => {
    return {
      ...state,
      fetchingLayoutTypesDrillDownTo: false,
      optionsLayoutTypesDrillDownTo: action.data
    };
  }
  //#endregion
};

export const chartReducer: Reducer<ChartState> = (state: ChartState = INITIAL_STATE, action: any) => {
  const r = chartReducers[action.type];
  return (r && r(state, action)) || state;
};
